module.exports = __webpack_public_path__ + "img/sd-b-a-1.961c7fc8.jpg";